/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const plant = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.88 5.823s-.986 1.687-2.415 1.45C1.567 6.788 2.05 2.924 1.084 1.475a6.406 6.406 0 0 1 5.796.483c1.447.966 1.447 2.415 0 3.864Zm0 0c.922 1.192 1.302 2.884 1.449 4.347.493-1.48 1.112-2.456 1.6-3.057m0 0c-.884-.963-.844-1.915.12-2.558a5.487 5.487 0 0 1 2.196-.781c.918-.131 2.021-.145 2.671.12-.674 1.007-1.177 4.016-3.189 4.351-.993.164-1.678-1.006-1.678-1.006a4.062 4.062 0 0 1-.12-.126ZM10.348 15H6.31a.483.483 0 0 1-.473-.386l-.773-3.864a.483.483 0 0 1 .473-.58h5.583a.484.484 0 0 1 .474.58l-.772 3.864a.483.483 0 0 1-.474.386Z"
    />
  </svg>
)
export default plant
